/* CurvaShop – script del tema */
(function () {
  'use strict';
  var CS = window.CS || {};
  var I18N = (document.getElementById('cs-i18n') || { dataset: {} }).dataset;
  function tr(k, fb) { return I18N[k] || fb; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: cur });
  }

  /* avviso in basso */
  function toast(html) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = html; t.className = 's';
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.className = ''; }, 3500);
  }

  /* barra annunci: su telefono un messaggio alla volta */
  $$('[data-rotate]').forEach(function (bar) {
    var s = $$('span', bar), i = 0; if (!s.length) return;
    s[0].classList.add('on');
    if (s.length > 1) setInterval(function () { s[i].classList.remove('on'); i = (i + 1) % s.length; s[i].classList.add('on'); }, 3000);
  });

  /* conto alla rovescia fino a domenica 23:59 */
  var cds = $$('[data-countdown]');
  if (cds.length) {
    var endOfWeek = function () { var d = new Date(), e = new Date(d); e.setDate(d.getDate() + ((7 - d.getDay()) % 7)); e.setHours(23, 59, 59, 0); if (e <= d) e.setDate(e.getDate() + 7); return e; };
    var END = endOfWeek();
    var p = function (v) { return (v < 10 ? '0' : '') + v; };
    var tick = function () {
      var s = Math.max(0, Math.floor((END - new Date()) / 1000)); if (!s) END = endOfWeek();
      var dd = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
      cds.forEach(function (el) { el.textContent = (dd ? dd + tr('daysShort', 'g') + ' ' : '') + p(h) + ':' + p(m) + ':' + p(x); });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ordinamento collezione */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', this.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* contatore carrello */
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    });
  }

  CS.toast = toast;
  CS.refreshCount = refreshCount;

  /* pagina prodotto */
  var sec = $('[data-product-section]');
  if (sec) {
    var data = JSON.parse($('[data-product-json]', sec).textContent);
    var form = $('[data-product-form]', sec);
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add]', sec);
    var errEl = $('[data-error]', sec);

    var selected = function () {
      var vals = [];
      $$('[data-option]:checked', sec).forEach(function (r) { vals[+r.getAttribute('data-option')] = r.value; });
      return vals;
    };
    var findVariant = function (vals) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; }); })[0];
    };
    var update = function () {
      var v = findVariant(selected());
      if (!v) { addBtn.disabled = true; addBtn.textContent = tr('unavailable', 'Non disponibile'); return; }
      idInput.value = v.id;
      $('[data-price]', sec).textContent = money(v.price);
      var cmp = $('[data-compare]', sec);
      if (cmp) { if (v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare_at_price); } else cmp.hidden = true; }
      var kl = $('[data-klarna]', sec); if (kl) kl.textContent = money(Math.floor(v.price / 3));
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? tr('addToCart', 'Aggiungi al carrello') : tr('soldOut', 'Esaurita');
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      if (v.featured_media && v.featured_media.preview_image) {
        /* la galleria scorre fino alla foto della variante scelta */
        var gal = $('[data-gallery]', sec);
        if (!(gal && gal.csGoToMedia && gal.csGoToMedia(v.featured_media.id))) {
          var imgs = $$('.gal-i img', sec);
          if (imgs[0]) { imgs[0].removeAttribute('srcset'); imgs[0].src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; }
        }
      }
    };
    $$('[data-option]', sec).forEach(function (r) { r.addEventListener('change', update); });

    /* nome e numero con anteprima */
    var nm = $('[data-pers-name]', sec), nu = $('[data-pers-num]', sec), pv = $('[data-pv]', sec);
    var preview = function () {
      if (!pv) return;
      var n = nm.value.trim(), m = nu.value.trim();
      pv.hidden = !(n || m);
      $('[data-pv-name]', pv).textContent = n || tr('namePlaceholder', 'NOME');
      $('[data-pv-num]', pv).textContent = m || '10';
      var t = $('[data-pv-name]', pv); t.setAttribute('font-size', n.length > 9 ? 18 : n.length > 6 ? 23 : 28);
    };
    if (nm) nm.addEventListener('input', function () {
      var p = this.selectionStart, v = this.value.toUpperCase().replace(/[^A-ZÀ-ÖØ-Ý' .-]/g, '');
      if (v !== this.value) { this.value = v; try { this.setSelectionRange(p, p); } catch (e) {} }
      preview();
    });
    if (nu) nu.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 2); preview(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var qty = Math.max(1, parseInt(form.querySelector('[name="quantity"]').value, 10) || 1);
      var props = {}, n = nm ? nm.value.trim() : '', m = nu ? nu.value.trim() : '';
      if (n) props['Nome'] = n;
      if (m) props['Numero'] = m;
      var items = [{ id: +idInput.value, quantity: qty, properties: props }];
      if ((n || m) && CS.persVariant) {
        items.push({ id: CS.persVariant, quantity: qty, properties: { 'Maglia': data.title, 'Nome': n, 'Numero': m } });
      }
      addBtn.disabled = true;
      fetch((CS.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          refreshCount();
          var tt = document.createElement('span'); tt.textContent = data.title;
          toast(tt.innerHTML + ' ' + tr('addedToCart', 'aggiunta al carrello') + ' <a href="' + (CS.cartUrl || '/cart') + '">' + tr('viewCart', 'Vedi carrello') + '</a>');
        })
        .catch(function (err) {
          errEl.textContent = (err && (err.description || err.message)) || tr('addError', 'Non è stato possibile aggiungere la maglia. Riprova.');
          errEl.hidden = false;
        })
        .then(function () { update(); });
    });
  }
})();
